"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportFactory = void 0;
var common_report_1 = require("./common-report");
var ReportFactory = /** @class */ (function () {
    function ReportFactory() {
    }
    ReportFactory.createReport = function () {
        return new common_report_1.CommonReport;
    };
    return ReportFactory;
}());
exports.ReportFactory = ReportFactory;
exports.default = ReportFactory.createReport();
